// Utils
import {
  getERC20TokenClient,
  getERCTokenClientWithSigner,
  getERC20StakeManagerClient,
} from "utils/clients";

// Types
import { NetworkConfigType } from "config/network/types";

export const getTokenBalance = async (
  config: NetworkConfigType,
  signer: any
) => {
  const signerAddress = await signer.getAddress();
  const isPolygonChainActive = config.chainId === "0x89";

  const client = getERC20TokenClient(
    config.contractAddresses.erc20,
    config.abis.erc20,
    isPolygonChainActive
  );
  const balance = await client.balanceOf(signerAddress);

  return balance;
};

export const getAllowance = async (config: NetworkConfigType, signer: any) => {
  const signerAddress = await signer.getAddress();
  const isPolygonChainActive = config.chainId === "0x89";

  const client = getERC20TokenClient(
    config.contractAddresses.erc20,
    config.abis.erc20,
    isPolygonChainActive
  );
  const allowance = await client.allowance(
    signerAddress,
    config.contractAddresses.xtoken.token
  );

  return allowance;
};

export const addApproval = async (
  config: NetworkConfigType,
  signer: any,
  amount: any,
  isIncrement: boolean
) => {
  const client = await getERCTokenClientWithSigner(
    config.contractAddresses.erc20,
    config.abis.erc20,
    signer
  );

  let txn;

  if (isIncrement) {
    txn = await client.increaseAllowance(
      config.contractAddresses.xtoken.token,
      amount
    );
  } else {
    txn = await client.approve(config.contractAddresses.xtoken.token, amount);
  }

  return txn;
};

export const getCurrentEpoch = async (config: NetworkConfigType) => {
  const isPolygonChainActive = config.chainId === "0x89";

  const client = getERC20StakeManagerClient(
    config.contractAddresses.sfc,
    config.abis.sfc,
    isPolygonChainActive
  );
  const response = await client.currentEpoch();
  return +response.toString();
};
